import { Pipe, PipeTransform } from '@angular/core';
import { MenuNode } from '../classes/';
@Pipe({
    name: 'enabledNodes',
    standalone: false
})
export class EnabledNodesPipe implements PipeTransform {

	transform(nodes: Array<MenuNode>, args?: any): Array<MenuNode> {
		return nodes.filter(node => node.isEnabled());
	}

}
